import { memo } from "react";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import Avtar from "./Avtar";

//Following Components Just Displays Class Details on the Navbar
function HostName() {
  const {  classesName, photoHostUrl, userNameHost } = useLiveStreamAppContext()
  return (
    <>
      <div className="livestreamAvatarDesktopWeb">
        <div className="livestreamAvatarDesktop">
          <Avtar photoUrl={photoHostUrl} userName={userNameHost} />
          <div className="avatar-title-box">
            <h2>{classesName}</h2>
            <span className="small-titleAbb">{userNameHost}</span>
          </div>
        </div>
      </div>
    </>
  );
}
export default memo(HostName)